import { IAreaPart } from '../../types/offer';
import { numberToPrettyString } from '@cian/utils';

export const getIsRent = (paymentPeriod?: string | null): boolean => {
  return paymentPeriod === 'annual' || paymentPeriod === 'monthly';
};

export const getPrice = (
  isRent?: boolean,
  part?: IAreaPart,
): string => {
  if (part && part.price) {
    const { price } = part;

    return `${numberToPrettyString(price)} ₽${isRent ? '/мес' : ''}`;
  }

  return '';
};

export const getMinAreaPrice = (areas?: IAreaPart[], paymentPeriod?: string | null): string => {
  if (areas === undefined) {
    return '';
  }

  const sortedAreas = areas.sort((a, b) =>
    a.price && b.price ? a.price - b.price : 0);

  const minArea = sortedAreas[0];
  const isRent = getIsRent(paymentPeriod || '');

  return getPrice(isRent, minArea);
};
